import { DatabaseFieldType } from '@databases/types/database';
import { type MessageDescriptor } from 'react-intl-next';

import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';

import { messages } from './messages.ts';

export const getFieldTypeName = (fieldType: DatabaseFieldType) => {
  const definitions: {
    [key in DatabaseFieldType]: MessageDescriptor;
  } = {
    [DatabaseFieldType.TEXT]: messages['field-settings.type-text'],
    [DatabaseFieldType.AI_SUMMARY]: messages['field-settings.type-ai-summary'],
    [DatabaseFieldType.ATTACHMENT]: messages['field-settings.type-attachment'],
    [DatabaseFieldType.NUMBER]: messages['field-settings.type-number'],
    [DatabaseFieldType.DATE]: messages['field-settings.type-date'],
    [DatabaseFieldType.CHECKBOX]: messages['field-settings.type-checkbox'],
    [DatabaseFieldType.SELECT]: messages['field-settings.type-tag'],
    [DatabaseFieldType.USER]: messages['field-settings.type-user'],
    [DatabaseFieldType.HYPERLINK]: messages['field-settings.type-link'],
    [DatabaseFieldType.PAGE_LINK]: messages['field-settings.type-content-link'],
    [DatabaseFieldType.PAGE_STATUS]: messages['field-settings.type-content-status'],
    [DatabaseFieldType.PAGE_LABELS]: messages['field-settings.type-content-label'],
    [DatabaseFieldType.PAGE_DETAILS]: messages['field-settings.type-content-details'],
    [DatabaseFieldType.ENTRY_LINK]: messages['field-settings.type-entry-link'],
    [DatabaseFieldType.ENTRY_DETAILS]: messages['field-settings.type-entry-details'],
    [DatabaseFieldType.BACKLINK]: messages['field-settings.type-entry-backlink'],
    [DatabaseFieldType.JIRA_ISSUE]: isFeatureFlagEnabled(
      'canvas-issue-terminology-refresh-update'
    )
      ? messages['field-settings.type-jira-issue-issue-terminology-refresh-m4']
      : messages['field-settings.type-jira-issue'],
    [DatabaseFieldType.JIRA_ISSUE_DETAILS]: isFeatureFlagEnabled(
      'canvas-issue-terminology-refresh-update'
    )
      ? messages['field-settings.type-jira-issue-details-issue-terminology-refresh-m4']
      : messages['field-settings.type-jira-issue-details']
  };

  return definitions[fieldType];
};
